import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Sem produtos ainda.',
  fields: {
    number: '#',
    image: 'Imagem',
    name: 'Nome',
    external_id: 'Ref. {{integration}}',
    price: 'Preço',
    prices: 'Preços',
    description: 'Descrição',
    tags: 'Etiquetas',
    status: 'Estado',
    product_type: 'Tipo',
    statuses: {
      good: 'Bom',
      bad: 'Mau',
      medium: 'Médio',
    },
    product_types: {
      packaged: 'Embalado',
      prepared: 'Preparado',
    },
  },
  labels: {
    visible: 'Visível no menu',
    hidden: 'Todos ocultos',
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Takeaway',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.on_site]: 'Pedidos à mesa',
  },
  buttons: {
    delete_products_one: 'Eliminar produto',
    delete_products_other: 'Eliminar produtos',
    add_product: '+ Adicionar produto',
    show_products: 'Mostrar produtos',
    hide_products: 'Ocultar produtos',
    add: 'Adicionar',
    edit: 'Editar',
    duplicate: 'Duplicar',
    history: 'Histórico',
    delete: 'Eliminar',
    delete_all: 'Eliminar todos',
  },
  toasts: {
    failed_to_duplicate_category: 'Falha ao duplicar categoria',
    category_duplicated_successfully: 'Categoria duplicada com sucesso',
    failed_to_duplicate_product: 'Falha ao duplicar produto',
    product_duplicated_successfully: 'Produto duplicado com sucesso',
    failed_to_delete_variant: 'Falha ao eliminar variante',
    variant_got_deleted: 'Variante eliminada',
    something_went_wrong: 'Algo correu mal',
  },
};
